import { Routes, Route, Navigate } from 'react-router-dom';
import { ClientLayout } from './layouts/ClientLayout';
import { PortfolioDashboardPage } from './pages/PortfolioDashboardPage';
import { DepositPage } from './pages/DepositPage';
import { BorrowPage } from './pages/BorrowPage';
import { WithdrawPage } from './pages/WithdrawPage';
import { RepayPage } from './pages/RepayPage';
import { CreditFacilitiesPage } from './pages/CreditFacilitiesPage';
import { CreditFacilityDetailPage } from './pages/CreditFacilityDetailPage';
import { FacilityAccessPage } from './pages/FacilityAccessPage';
import { QualificationPage } from './pages/QualificationPage';
import { KycPage } from './pages/KycPage';
import { LenderDashboardPage } from './pages/LenderDashboardPage';
import { LenderPositionDetailPage } from './pages/LenderPositionDetailPage';
import { LenderDepositPage } from './pages/LenderDepositPage';
import { LenderWithdrawPage } from './pages/LenderWithdrawPage';
import { LenderYieldPage } from './pages/LenderYieldPage';
import { LiquidationsPage } from './pages/LiquidationsPage';
import { LiquidationExecutePage } from './pages/LiquidationExecutePage';
import { DdfAuctionDetailPage } from './pages/DdfAuctionDetailPage';
import { LiquidationHistoryPage } from './pages/LiquidationHistoryPage';
import { LiquidationClaimPage } from './pages/LiquidationClaimPage';
import { CreateMarginAccountPage } from './pages/CreateMarginAccountPage';
import { MarginAccountDetailPage } from './pages/MarginAccountDetailPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { HistoryPage } from './pages/HistoryPage';
import { ProfilePage } from './pages/ProfilePage';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<ClientLayout />}>
        {/* Borrower: Portfolio Dashboard (root) */}
        <Route index element={<PortfolioDashboardPage />} />

        {/* Profile */}
        <Route path="profile" element={<ProfilePage />} />

        {/* Borrower: Core Operations */}
        <Route path="deposit" element={<DepositPage />} />
        <Route path="borrow" element={<BorrowPage />} />
        <Route path="withdraw" element={<WithdrawPage />} />
        <Route path="repay" element={<RepayPage />} />
        <Route path="credit-facilities" element={<CreditFacilitiesPage />} />
        <Route path="credit-facilities/:id" element={<CreditFacilityDetailPage />} />
        <Route path="facility-access" element={<FacilityAccessPage />} />
        <Route path="qualification" element={<QualificationPage />} />
        <Route path="kyc" element={<KycPage />} />
        <Route path="margin-accounts/create" element={<CreateMarginAccountPage />} />
        <Route path="margin-accounts/:accountId" element={<MarginAccountDetailPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="history" element={<HistoryPage />} />

        {/* Borrower: Liquidations */}
        <Route path="liquidations" element={<LiquidationsPage />} />
        {/* Explicit path so /liquidations/execute/:id is not parsed as accountId "execute" */}
        <Route path="liquidations/execute/:accountId" element={<LiquidationExecutePage />} />
        <Route path="liquidations/:accountId" element={<LiquidationExecutePage />} />
        <Route path="liquidations/auction/:auctionId" element={<DdfAuctionDetailPage />} />
        <Route
          path="liquidations/bids"
          element={<Navigate to="/liquidations?tab=ddf" replace />}
        />
        <Route path="liquidations/history" element={<LiquidationHistoryPage />} />
        <Route path="liquidations/claim/settlement" element={<LiquidationClaimPage />} />

        {/* Lender Portal */}
        <Route path="lender/dashboard" element={<LenderDashboardPage />} />
        <Route path="lender/position/:poolId" element={<LenderPositionDetailPage />} />
        <Route path="lending/:poolId" element={<LenderPositionDetailPage />} />
        <Route path="lender/deposit" element={<LenderDepositPage />} />
        <Route path="lender/withdraw" element={<LenderWithdrawPage />} />
        <Route path="lender/yield" element={<LenderYieldPage />} />
      </Route>
    </Routes>
  );
}
